'use client'
import type { PropsWithChildren } from 'react'
import { carDealershipBlocks } from '@/features/carDealership/carDealershipBlocks'
import { appRouterStoryblokComponents } from '@/services/storyblok/appRouterStoryblokComponents'
import { commonStoryblokComponents } from '@/services/storyblok/commonStoryblokComponents'
import { storyblokInit } from '@storyblok/react/rsc'

storyblokInit({
  components: {
    ...commonStoryblokComponents,
    ...appRouterStoryblokComponents,
    ...carDealershipBlocks,
  },
})

// The main purpose of this component is to call storyblokInit client-side
// We may want to set current list of blocks in the future:
// https://github.com/storyblok/storyblok-react?tab=readme-ov-file#3-adding-components-per-page
export function StoryblokProvider({ children }: PropsWithChildren) {
  return children
}
